<script>
  export default {
    data() {
      return {
        oggSource: `/music/bell_ring.ogg`,
        mp3Source: `/music/bell_ring.mp3`,
        intervalId: null
      };
    },
    methods: {
      playSound() {
        this.$refs.audioElement.play();
      },
      startPlayingSound(frequency) {
        if (this.intervalId) {
          clearInterval(this.intervalId);
        }
        this.intervalId = setInterval(() => {
          this.playSound();
        }, frequency);
      },
      stopPlayingSound() {
        if (this.intervalId) {
          clearInterval(this.intervalId);
          this.intervalId = null;
        }
      }
    }
  };
</script>

<template>
    <div>
      <audio id="sound_beep" ref="audioElement" >
        <source :src="mp3Source" type="audio/mpeg">
        Your browser does not support the audio element.
      </audio>
    </div>
  </template>

  